module.exports = __webpack_public_path__ + "static/media/tachometer-slowest.35cc0dfc.svg";